import { useEffect, useState } from 'react';
import { Container, Spinner } from 'react-bootstrap';
import './App.css';
import Header from './components/Header/Header';
import NavigationTab from './components/NavigationTab/NavigationTab';
import PowerBIEmbedded from './components/PowerBIEmbedded/PowerBIEmbedded';
import FinalOutcomeReport from './components/FinalOutcomeReport/FinalOutcomeReport';
import HandleLogin from './components/HandleLogin/HandleLogin';
import {
  UserDetailsObject,
  UserUloadDetailsObject,
} from './components/interfaces';
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import {
  getLoggedInUserDetails,
  getUserUloadDetails,
} from './components/apiCalls';
import ErrorContainer from './components/UtilContainer/ErrorContainer';
import { DISPLAY, ERRORS } from './components/constants';
import {
  Route,
  BrowserRouter as Router,
  Routes,
  Navigate,
} from 'react-router-dom';
import Uload from './components/Uload/Uload';

const App: React.FC = () => {
  type ValueOf<T> = T[keyof T];
  const [selectedView, setSelectedView] = useState<string>(DISPLAY.POWERBI);
  document.title =
    selectedView === DISPLAY.POWERBI
      ? 'BSR Application'
      : selectedView === DISPLAY.WORKFLOW
      ? 'BSR | Final Outcome Report'
      : 'BSR | Uload';
  const [displayStatus, setDisplayStatus] = useState<string>(DISPLAY.LOADING);
  const [displayUloadStatus, setDisplayUloadStatus] = useState<string>(
    DISPLAY.DEFAULT
  );
  const [authenticationState, setAuthenticationState] = useState<
    ValueOf<typeof DISPLAY>
  >(DISPLAY.LOADING);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [userDetails, setUserDetails] = useState<UserDetailsObject[]>([]);
  const [userUloadDetails, setUserUloadDetails] = useState<
    UserUloadDetailsObject[]
  >([]);
  useEffect(() => {
    const fetchUloadData = async () => {
      if (authenticationState === DISPLAY.AUTHENTICATED) {
        try {
          const userUloadDataResponse = await getUserUloadDetails(
            sessionStorage.getItem('userEmail') || ''
          );
          setUserUloadDetails(userUloadDataResponse);
          if (userUloadDataResponse.length === 0) {
            setErrorMessage(ERRORS.ACCESS_ON_REPORT);
            setDisplayUloadStatus(DISPLAY.ERROR);
          } else {
            setDisplayUloadStatus(DISPLAY.SUCCESS);
          }
        } catch (e) {
          setErrorMessage(String(e));
          setDisplayStatus(DISPLAY.ERROR);
        }
      }
    };
    const fetchUserData = async () => {
      if (authenticationState === DISPLAY.AUTHENTICATED) {
        try {
          const userDataResponse = await getLoggedInUserDetails(
            sessionStorage.getItem('userEmail') || ''
          );
          setUserDetails(userDataResponse);
          if (userDataResponse.length === 0) {
            setDisplayStatus(DISPLAY.ERROR);
          } else {
            setDisplayStatus(DISPLAY.SUCCESS);
          }
          fetchUloadData();
        } catch (e) {
          setErrorMessage(String(e));
          setDisplayStatus(DISPLAY.ERROR);
        }
      }
    };
    fetchUserData();
  }, [authenticationState]);

  const isLoading =
    authenticationState === DISPLAY.LOADING ||
    displayStatus === DISPLAY.LOADING;
  const errorOccurred =
    authenticationState === DISPLAY.NOT_AUTH ||
    (displayStatus === DISPLAY.ERROR && displayUloadStatus === DISPLAY.ERROR);
  const isSucess = displayStatus === DISPLAY.SUCCESS;
  const isUloadSuccess = displayUloadStatus === DISPLAY.SUCCESS;
  return (
    <Router>
      {' '}
      <div className='App'>
        <HandleLogin setAuthenticationState={setAuthenticationState} />
        {isLoading && (
          <Container className='loadingScreen'>
            <Spinner animation='grow' />
            <p>Loading</p>
          </Container>
        )}
        {errorOccurred && <ErrorContainer message={errorMessage} />}
        {(isSucess || isUloadSuccess) && (
          <div>
            <Header />
            <NavigationTab
              selectedView={selectedView}
              setSelectedView={setSelectedView}
              isSucess={isSucess}
              isUloadSuccess={isUloadSuccess}
            />
            <Routes>
              <>
                {isSucess && (
                  <>
                    <Route
                      path='OutcomeReport/*'
                      element={
                        <div className={'finalOutcomeContainer m-3'}>
                          <FinalOutcomeReport userData={userDetails} />
                        </div>
                      }
                    />
                    <Route
                      path={'Report/*'}
                      element={
                        <div>
                          <PowerBIEmbedded userDataList={userDetails} />
                        </div>
                      }
                    />
                    <Route
                      path={'/'}
                      element={<Navigate replace to='/Report' />}
                    />
                  </>
                )}
                {isUloadSuccess && (
                  <>
                    <Route
                      path='Uload/*'
                      element={
                        <div className={'uloadContainer m-3'}>
                          <Uload
                            uloadDisplayStatus={displayUloadStatus}
                            userData={userUloadDetails}
                          />
                        </div>
                      }
                    />
                  </>
                )}
                {!isSucess && (
                  <Route
                    path={'/'}
                    element={<Navigate replace to='/Uload' />}
                  />
                )}
              </>
            </Routes>
          </div>
        )}
      </div>
    </Router>
  );
};

export default App;
